<template>
  <div class="bj pt50">
    <div class="container">
      <div class="breadcrumb-wrapper">
        <router-link to="/">首页</router-link>>
        <span>拼团</span>
      </div>
      <div class="sku-list-container assemble-list" v-if="shopList.length">
        <div class="sku-item-wrapper">
          <div class="recommend-wrapper">
            <el-card class="sku-item-card" shadow="hover" style="margin-right:12px;width: 270px;height:303px" v-for="sku in shopList" :key="sku.id" >
              <div  @click="toAssemble(sku.id,sku.skuId)">
                <div class="sku-cover-wrapper" >
                  <el-image
                      class="sku-cover"
                      :src="sku.imgUrl"
                      fit="contain"
                  >
                  </el-image>
                </div>
                <div class="sku-description">
                  <p class="name">{{sku.skuName}}</p>
                  <p class="purpose">{{sku.skuSharerDescribe}}</p>
                </div>
                <div style="padding: 6px 5px;">
                  <div class="v-progress-component">
                    <span class="v-proportion">{{sku.proportion}}</span>
                    <div class="v-progress-wrapper" :style="{width:sku.proportion}"></div>
                  </div>
                </div>
                <div class="sku-footer">
                  <div class="l">
                    <p class="price"><span>¥</span>{{sku.skuPrice}}</p>
                    <!--<span>{{sku.buyNum}}/{{sku.stock}}</span>-->
                    <v-count-down :prefix="'剩余时间'" style="font-size: 12px;" :time="sku.closingDate"/>
                  </div>
                  <div class="r">
                    <p class="btn">立即抢购</p>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>

      <div class="sku-list-container" v-else>
        <div class="empty">
          <img src="./images/u806.svg" />
          <p>暂无对应商品</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';

export default {
  data() {
    return {
      parentId: '',
      twoId: '',
      menuId: '',
      categoryThreeList: [],
      tab: 0,
      firstMap: {},
      twoMap: {},
      shopList: [],
      pagination: {
        count: 0,
        pageNumber: 0,
        pageSize: 0,
        pages: 1
      },
      categoryTwoList: []
    };
  },
  computed: {
   ...mapGetters(['firstMenu','twoMenu','code'])
  },
  watch: {
    code(val){
      this.getDetailedList(val)
    }
  },
  async mounted(){
    let code = Cookies.get('code');
    this.getDetailedList(code);
  },
  methods: {
    toAssemble(id,skuId){
      this.$router.push(`/assemble/${id}/${skuId}`)
    },
    // 拼团
    async getDetailedList(regionCode){
      let res = await this.$get('/api/getAssembleList',{
        regionCode
      });
      if(res.code==='200'){
        res.assembleList.forEach(sku=>{
          const stock = Number(sku.buyNum)+Number(sku.skuNum);
          sku['stock']= stock;
          const proportion = (Number(sku.buyNum)/stock *100).toFixed(2);
          sku['proportion'] =proportion+'%';
        });
        this.shopList = res.assembleList;
      }else{
        this.shopList = []
      }
    },
  }
};
</script>

<style lang="scss" scpoped>
.empty{
  padding: 200px 0;
  text-align: center;
  img{
    width: 115px;
    height: 115px;
  }
  p{
    font-size: 20px;
    color: #999999;
    line-height: 42px;
  }
}
.sku-types {
  padding: 11px 64px 0;
  margin-bottom: 9px;
  // height: 158px;
  min-height: 58px;
  padding-bottom: 20px;
  //border: 1px #e4e4e4 solid;
  background: #fff;
  dl {
    display: flex;
    line-height: 48px;
    min-height: 48px;
    border-bottom: 1px #ededed solid;
    overflow: hidden;
    dt {
      flex: 0 0 50px;
      padding-left: 11px;
      width: 55px;
      font-size: 12px;
      color: #999999;
    }
    p {
      float: left;
      min-width: 45px;
      padding: 0 10px;
      font-size: 12px;
      text-align: center;
      span {
        cursor: pointer;
        &:hover,
        &.cur {
          color: rgb(26, 188, 156);
        }
      }
    }
  }
}
.sku-list-container {
  border: 1px #e4e4e4 solid;
  padding: 32px 64px 40px;
  background: #fff;
  .sort-wrapper {
    height: 60px;
    button {
      margin-right: 10px;
      width: 78px;
      height: 28px;
      border: 1px #e4e4e4 solid;
      background: none;
      cursor: pointer;
      font-size: 12px;
      color: #999999;
      .fa {
        font-size: 14px;
        font-family: FontAwesome;
        color: #999;
      }
      &:hover {
        color: #1abc9c;
        border-color: #1abc9c;
        .fa {
          color: #1abc9c;
        }
      }
      &.cur {
        color: #fff;
        border-color: #1abc9c;
        background: #1abc9c;
        .fa {
          color: #fff;
        }
      }
    }
  }
  .sku-item-wrapper {
    overflow: hidden;
    .sku-group{
      width: 1120px;
      overflow: hidden;
    }
    .sku-item-card {
      margin-right: 50px;
      margin-bottom: 20px;
    }
  }
}
.assemble-list{
  padding: 32px 10px 40px 37px;
  .recommend-wrapper{
    width: 1204px;
    overflow: hidden;
  }
}
.v-progress-component{
  position: relative;
  width: 100%;
  height: 14px;
  border-radius: 8px;
  background: #e6e6e6;
  overflow: hidden;
  .v-proportion{
    position: absolute;
    left: 50%;
    top: 1px;
    font-size: 12px;
    transform: scale(0.8) translateX(-50%);
    color:#fff;
  }
  .v-progress-wrapper{
    width: 50%;
    height: 100%;
    border-radius: 8px;
    background: #f35b6f;
  }
}
.sku-footer{
  padding: 2px 12px 0;
  display: flex;
  justify-content: space-between;
  .r{
    display: flex;
    align-items: center;
  }
  .btn{
    width: 70px;
    height: 36px;
    font-size: 13px;
    color:#fff;
    line-height: 36px;
    background: #df0021;
    text-align: center;
    border-radius: 3px;
  }
  .price{
    font-size: 20px;
    color:#f00;
    font-weight: bold;
    font-family: Arial;
    margin-bottom: 5px;
    span{
      color:#f00;
      font-size: 14px;
      font-weight: normal;
    }
  }

}
</style>
